const slider = document.querySelector('.js-hero-slider');

if (slider) {
    const previous = document.querySelector('.js-hero-slider-previous');
    const next = document.querySelector('.js-hero-slider-next');

    const flkty = new window.Flickity(slider, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        on: {
            ready() {
                const video = this.selectedCell.element.querySelector('video');

                function onEnd() {
                    this.next();
                    this.playPlayer();
                    video.removeEventListener('ended', onEnd);
                }

                if (video) {
                    this.stopPlayer();

                    video.addEventListener('ended', onEnd);

                    video.play();
                }
            },
        },
        // freeScroll: true,
    });

    flkty.on('select', () => {
        const autoPlay = flkty.player.state === 'playing';
        const video = flkty.selectedCell.element.querySelector('video');

        function onEnd() {
            if (autoPlay) {
                flkty.next();
                flkty.playPlayer();
                video.removeEventListener('ended', onEnd);
            } else {
                video.play();
            }
        }

        if (video) {
            flkty.stopPlayer();

            video.addEventListener('ended', onEnd);

            video.play();
        }
    });


    previous.addEventListener('click', () => {
        flkty.stopPlayer();
        flkty.previous();
    });

    next.addEventListener('click', () => {
        flkty.stopPlayer();
        flkty.next();
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/heroSlider.js